import { render, staticRenderFns } from "./DynamicAutoHeightInfoBox.vue?vue&type=template&id=05972160&"
import script from "./DynamicAutoHeightInfoBox.vue?vue&type=script&lang=js&"
export * from "./DynamicAutoHeightInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./DynamicAutoHeightInfoBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports